import { StyleSheet, Text, View } from 'react-native'
import React, { useContext } from 'react'
import { DataContext } from '../components/DataContext'
import { AuthContext } from '../context/AuthContext'

export default function useAuth() {
    const context = useContext(AuthContext)

    return context
}

